'use strict';

/**
 * Component for the set selection
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Collection = require('base/Colido.Collection');
var LayoutView = require('base/Colido.LayoutView');
var SelectSetOverlayLayout = require('modules/collection/modules/set/views/layout/select-set-overlay');

var template = require('../../templates/components/field-sets.hbs');

var SetsComponent = LayoutView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'form-component component-' + _.camelToHyphen(field.type);
    },

    attributes: {
        'data-state': 'pending',
    },

    ui: {
        'buttonChooseSet': '[data-action="choose-set"]',
        'setInput': '[name="setIds"]',
        'buttonRemoveSet': '[data-action="remove-set"]',
    },

    events: {
        'click @ui.buttonChooseSet': 'onActionChooseSet',
        'click @ui.buttonRemoveSet': 'onActionRemoveSet',
    },

    /**
     * States for this component
     * @type {object}
     */
    STATES: {
        PENDING: 'pending',
        SELECTED: 'selected',
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },

        isGroupChild: function() {
            return this.getOption('isGroupChild');
        },
    },

    initialize: function(options) {
        LayoutView.prototype.initialize.apply(this, arguments);

        this.collection = new Collection();

        _.each(this.model.getSets(), function(setModel){
            this.onSetSelected(setModel);
        }.bind(this));

        this.listenTo(this.collection, 'add remove change', this.render);
    },

    /**
     * Resets the states and data of the component
     */
    reset: function() {
    },

    /**
     * Triggered, when set should be selected
     */
    onActionChooseSet: function() {
        App.addModal(new SelectSetOverlayLayout({
            mode: 'select',
            collection: this.model.collection,
            showCreateMessage: false,
        }), {
            additionalClassName: 'modal-left modal-medium modal-select-set',
            onAfterClose: function(data) {
                if (data) {
                    this.onSetSelected(data.setModel);
                }
            }.bind(this),
        });
    },

    /**
     * Triggered, when set should be removed
     */
    onActionRemoveSet: function(event) {
        var id = $(event.currentTarget).data('forid');
        this.$('[data-item-id="' + id + '"]').addClass('deleted');

        setTimeout(function(){
            this.collection.remove({id: id});
        }.bind(this), 500);
    },

    /**
     * Triggered, when a set is selected in model
     * @param {SetModule.SetModel} model The set model
     */
    onSetSelected: function(model) {
        this.collection.add(model);

        if (this.collection.length){
            this.setState(this.STATES.SELECTED);
        }
    },

    /**
     * Sets the state of the component
     * @param {string} state The state to set
     */
    setState: function(state) {
        this.$el.attr('data-state', state);
    },

    getData: function() {
        var data = {};
        var field = this.getOption('field');

        var setIds = [];
        _.each(this.collection.models, function(obj){
            setIds.push(obj.get('id'));
        });

        data[field.name] = _.compact(setIds).map(function(setId) { return parseInt(setId, 10); });

        return data;
    },
});

module.exports = SetsComponent;